import { createUseStyles, withTheme } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Tooltip.styles';
import Position from './Position';
import './themeDefaults';

const useStyles = createUseStyles(styles);

const Tooltip = ({ selection, format }) => {
  const classes = useStyles();

  return (
    <Position
      className={classes.tooltip}
      scroll
      dataQa="tooltip-position"
    >
      <div className={classes.contentWrapper}>
        {selection.map(option => (
          <p key={option.name}>
            {option.path && option.path.map((step, idx) => (idx < option.path.length && `${step.name} > `)) }
            {format(option)}
          </p>
        ))}
      </div>

    </Position>
  );
};

Tooltip.propTypes = {
  /** Function to format the appearance of the label printed in the tooltip */
  format: PropTypes.func.isRequired,
  /** Selection made by user  */
  selection: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default withTheme(Tooltip);
